import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Img, { ImgProps } from "@insite/mobius/Img";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    categoryBannerDispatch,
    mapCategoryBannerStateToProps,
} from "@thkStore/Store/Selectors/CategoryBannerSelectors";
import * as React from "react";
import { FC, useEffect, useRef } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = mapCategoryBannerStateToProps;
const mapDispatchToProps = categoryBannerDispatch;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CategoryBannerImageStyles {
    wrapper?: InjectableCss;
    img?: ImgProps;
}

export const categoryBannerImageStyles: CategoryBannerImageStyles = {
    wrapper: {
        css: css`
            width: 100%;
            display: block;
            margin-bottom: 24px;

            @media (max-width: 768px) {
                margin-bottom: 16px;
            }
        `,
    },
    img: {
        css: css`
            width: 100%;
            height: auto;
            display: block;
        `,
    },
};

const styles = categoryBannerImageStyles;

const CategoryBannerImage: FC<Props> = ({
    categoryId,
    category,
    parentCategoryId,
    parentCategory,
    imagePath,
    altText,
    loadCategory,
}) => {
    const attemptedIdsRef = useRef<Set<string>>(new Set());

    useEffect(() => {
        if (!categoryId) {
            return;
        }
        const propsLoaded = category && Object.keys(category.properties || {}).length > 0;
        if (propsLoaded) {
            return;
        }
        if (attemptedIdsRef.current.has(categoryId)) {
            return;
        }
        attemptedIdsRef.current.add(categoryId);
        loadCategory({ id: categoryId });
        
    }, [categoryId, category, loadCategory]);

    useEffect(() => {
        if (!parentCategoryId) {
            return;
        }
        const propsLoaded = parentCategory && Object.keys(parentCategory.properties || {}).length > 0;
        if (propsLoaded) {
            return;
        }
        if (attemptedIdsRef.current.has(parentCategoryId)) {
            return;
        }
        attemptedIdsRef.current.add(parentCategoryId);
        loadCategory({ id: parentCategoryId });
    }, [parentCategoryId, parentCategory, loadCategory]);

    if (!imagePath) {
        return null;
    }

    return (
        <StyledWrapper className="category-banner-image-wrapper" {...styles.wrapper}>
            <Img
                className="category-banner-image"
                src={imagePath}
                altText={altText || ""}
                loading="lazy"
                {...styles.img}
                data-test-selector="categoryBannerImage"
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CategoryBannerImage),
    definition: {
        group: "Category Details",
        icon: "image-landscape",
        allowedContexts: ["CategoryDetailsPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
